module.exports = __webpack_public_path__ + "img/coronavirus.f19d2d4f.png";